
import React, { lazy } from 'react';
import Loadable from 'app/components/Loadable';
import SiteLayout from './SiteLayout';
import ARImagePage from './ARImageSection/ARImagePage';
import ObservationRoutesWrapper from './ObservationSection/ObservationRoutesWrapper';

const ProjectWorkspace = Loadable(lazy(() => import("./workspace/ProjectWorkspace")));
const ObservationPage = Loadable(lazy(() => import("./ObservationSection/ObservationPage")));
const QRPage = Loadable(lazy(() => import("./QRSection/QRPage")));
const ModelSection = Loadable(lazy(() => import("./ModelSection/ModelPage")));
const ObservationDetailsSection = Loadable(lazy(() => import("./ObservationSection/ObservationDetails")));




const siteRoutes = [
    {
        path: '/site/:siteId',
        element: <SiteLayout />, // SiteProvider is provided here
        children: [
            {
                path: 'details',
                element: <ProjectWorkspace />,
            },
            {
                path: '', // default route: unified project workspace
                element: <ProjectWorkspace />,
            },
            {
                path: 'observations',
                element: <ObservationRoutesWrapper />, // This applies the ObservationProvider
                children: [
                    {
                        path: '',
                        element: <ObservationPage />,
                    },
                    {
                        path: ':observationId',
                        element: <ObservationDetailsSection />,
                    },
                    {
                        path: 'ar-image-gallery',
                        element: <ARImagePage />,
                    }
                ],
            },
            {
                path: 'qr',
                element: <QRPage />,
            },
            {
                path: 'qr/:qrId',
                element: <QRPage />,
            },
            {
                path: 'models',
                element: <ModelSection />,
            },
        ],
    },
];

export default siteRoutes;
